import React from 'react'
import { Box, BreakPointProps } from 'component-library/compositions/Box/Box'
import { BaseCompositionProps } from '../types'
import { createRegisterableComposition } from 'common/routing/page-definition'
import { ThemeMargins, ContainerWidth } from 'component-library/__styling/settings/metrics'

export interface BoxRouteProps extends BaseCompositionProps {
    hasTopSpacing?: boolean
    verticalSpacing?: keyof ThemeMargins
    horizontalSpacing?: keyof ThemeMargins
    horizontalGutters?: keyof ThemeMargins
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    containerWidth?: ContainerWidth
    breakpoints?: BreakPointProps
    hasBackgroundFill?: boolean
    stickyOffset?: number
    fillContainer?: boolean
    positionOffset?: {
        direction: 'top' | 'bottom'
        value: number
    }
}

export const BoxRegistration = createRegisterableComposition<'main'>()(
    'box',
    (contentAreas, props: BoxRouteProps) => <Box {...props}>{contentAreas.main}</Box>
)
